<template>
  <div class="parallaxe-elem">
    <div class="parallaxe-elem__inner" ref="innerParallaxe">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import getAbsoluteBoundingRect from '@/utils/getAbsoluteBoundingRect.js'
import MathUtils from '@/utils/MathUtils'
import EventHub from '@/utils/EventHub'

export default {
  name: 'app-parallaxe-elem',

  props: {
    direction: {
      type: Number,
      default: -1
    },
    amount: {
      type: Number,
      default: 0.1
    }
  },

  computed: {
 
  },

  data() {
    return {
      observer: null,
      intersected: false,
      isActive: true
    }
  },

  created()
  {
    this.isParallaxing = false
    this.addEventListeners()
  },

  mounted()
  {
    this.initParallaxe()
    this.addObserver()

    this.onResize({width: window.innerWidth, height: window.innerHeight})
  },

  destroyed()
  {
    this.removeEventListeners()
    this.observer.disconnect()
  },

  methods: {
    addEventListeners()
    {
      EventHub.$on('window:resize', this.onResize)
      EventHub.$on('application:on-scroll', this.onScroll)
      EventHub.$on('application:on-tick', this.onTick)
    },

    removeEventListeners()
    {
      EventHub.$off('window:resize', this.onResize)
      EventHub.$off('application:on-scroll', this.onScroll)
      EventHub.$off('application:on-tick', this.onTick)
    },

    addObserver()
    {
      this.observer = new IntersectionObserver(entries => {
          this.handleObserver(entries)
      })

      this.observer.observe(this.$el)
    },

    handleObserver(entries)
    {
      const elem = entries[0]

      if (elem.isIntersecting) 
      {
        this.setParallaxeActive()
      }
      else
      {
        this.setParallaxeInactive()
      }
    },

    setParallaxeActive()
    {
      this.isParallaxing = true

      this.onScroll(window.scrollY)
      
      this.addEventListeners()
    },

    setParallaxeInactive()
    {
      this.isParallaxing = false

      this.removeEventListeners()
    },

    initParallaxe()
    {
      this.currentScroll = 0
      this.progress = 0

      this.parallaxe = {
        amplitude: 0,
        current: 0,
        target: 0
      }

      this.scale = 1 + this.amount

      this.limits = {}
    },

    onResize(windowObj)
    {
      this.windowObj = windowObj
      this.bounds = getAbsoluteBoundingRect(this.$el)

      this.limits.top = this.bounds.top - this.windowObj.height
      this.limits.bottom = this.bounds.bottom

      this.height = Math.round(this.bounds.height * 100) / 100

      this.parallaxe.amplitude = this.height * this.amount
    },

    onScroll(scrollY)
    {
      this.currentScroll = scrollY
    },

    onTick()
    {
      if(this.isParallaxing)
      {
        this.progress = MathUtils.clamp((this.currentScroll - this.limits.top) / (this.limits.bottom - this.limits.top), 0, 1)

        this.parallaxe.target = (this.parallaxe.amplitude / 2) - ( (1 - this.progress) * this.parallaxe.amplitude)
        this.parallaxe.current = MathUtils.lerp(this.parallaxe.current, this.parallaxe.target, 0.3)

        const val = this.direction * this.parallaxe.current
        // this.parallaxe.current = this.parallaxe.target

        if(this.$refs.innerParallaxe)
        {
          this.$refs.innerParallaxe.style.transform = `scale(${this.scale}) translate3d(0, ${val}px, 0)`
        }
      }
    }
  }
}
</script>

<style lang="stylus">

.parallaxe-elem
  overflow hidden
  width 100%
  height 100%

.parallaxe-elem__inner
  overflow hidden
</style>